import React from "react";
import { AppState, Auth0Provider } from "@auth0/auth0-react";

interface UniversalLoginProviderProps {
  audience?: string;
  callbackPath: string;
  children: React.ReactNode;
  clientId: string;
  domain: string;
  scope?: string;
}

export const isUniversalLoginConfigured = ({
  clientId,
  domain,
}: {
  clientId?: string;
  domain?: string;
}): boolean => Boolean(clientId && domain);

const isUniversalLoginCallbackPath = (
  callbackPath: string,
  pathname = window.location.pathname,
  search = window.location.search,
): boolean => {
  const searchParams = new URLSearchParams(search);
  return (
    pathname === callbackPath &&
    searchParams.has("state") &&
    (searchParams.has("code") || searchParams.has("error"))
  );
};

const buildRedirectCallback =
  (callbackPath: string) =>
  (appState?: AppState): void => {
    window.history.replaceState(
      window.history.state,
      document.title,
      appState?.returnTo || callbackPath,
    );
  };

export const UniversalLoginProvider = ({
  audience,
  callbackPath,
  children,
  clientId,
  domain,
  scope = "openid",
}: UniversalLoginProviderProps): React.ReactElement => (
  <Auth0Provider
    clientId={clientId}
    domain={domain}
    authorizationParams={{
      audience: audience || undefined,
      redirect_uri: `${window.location.origin}${callbackPath}`,
      scope,
    }}
    onRedirectCallback={buildRedirectCallback(callbackPath)}
    skipRedirectCallback={!isUniversalLoginCallbackPath(callbackPath)}
  >
    {children}
  </Auth0Provider>
);
